import { SelectAsyncInput } from '@core/components/Select';
import { centroCustoApi } from 'app/services/api/centroCustoApi';
import React from 'react';

const exibirApenasFilhas = (classes, classesFilhas = []) => {
  classes.forEach((classe) => {
    if (classe.classesFilhas) {
      exibirApenasFilhas(classe.classesFilhas, classesFilhas);
    } else {
      classesFilhas.push(classe);
    }
  });

  return classesFilhas;
};

const SelectClasseCentroCusto = ({
  id,
  multiple,
  name,
  label,
  value,
  touched,
  error,
  onBlur,
  onChange,
  required,
  disabled,
}) => {
  return (
    <SelectAsyncInput
      multiple={multiple}
      id={id}
      required={required}
      name={name}
      label={label}
      value={value}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option?.nome ? `${option.indice} - ${option?.nome}` : '';
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }

        const response = await centroCustoApi().buscarClasse({
          size: 100,
          page: next,
          q: query,
        });

        let data = response?.data || [];

        data = exibirApenasFilhas(data, []);
        const totalItemsNoMesmoNivel = data?.length;

        return { data, totalItemsNoMesmoNivel };
      }}
      fetchOnFocus
      disabled={disabled}
    />
  );
};

export default SelectClasseCentroCusto;
